import { atom } from 'recoil';
import { Rvoip } from '@/types/api/mypage/options';

/**
 * リモートサポート系VoIPオプション情報を保持する state。
 * 利用状態と付加サービス状態を変更画面や確認画面で共通利用するために保持する。
 */
export const RvoipOptionInfoState = atom<Rvoip>({
  key: 'RvoipOptionInfoState',
  default: {
    result_state: 'normal',
    rvoip_use_state: '未申込',
    add_service_info: {
      is_unnotifying_refusal: false,
      is_catch_phone: false,
      is_voice_warp: false,
    },
  },
});

export default RvoipOptionInfoState;
